import React from 'react';
import { withPinchZoom } from '../pinchZoom';

function PinchZoomShowcase({ pinchedX, pinchedY, pinchedScale }) {
  return (
    <div>
      <img
        alt="cato"
        src="https://www.catster.com/wp-content/uploads/2018/07/Savannah-cat-long-body-shot.jpg"
        width="100%"
      />
      <h3>Test on mobile</h3>
      <div>{`Pinch x: ${pinchedX}`}</div>
      <div>{`Pinch y: ${pinchedY}`}</div>
      <div>{`Scale: ${pinchedScale}`}</div>
    </div>
  );
}

export default withPinchZoom()(PinchZoomShowcase);
